module.exports = __webpack_public_path__ + "static/media/membership_mind_body_fitness_classes.6f65d993.webp";